import { listEvents, EventResponse } from '@goldcast/api/backend';

const actions = {
  async fetchRegistrableSeriesEvents(
    { rootGetters },
    seriesId: string
  ): Promise<{ allEvents: EventResponse[]; onDemandEventIds: string[] }> {
    const orgId = rootGetters['org/getCurrentOrgId'];
    const currentOrg = rootGetters['org/getCurrentOrg'];
    const series = rootGetters['studioSeriesList/getCurrentSeriesById'](seriesId);
    const isRepeatingEvent = series?.type === 'repeating';
    const canRegisterToOnDemandEvents = !isRepeatingEvent && !!currentOrg?.enableSeriesOnDemandBulkRegistration;
    const now = new Date();

    const liveAndUpcomingEventsPromise = listEvents({
      queryParams: {
        organization: orgId,
        series: seriesId,
        end_time_gte: now.toISOString(),
        ordering: 'start_time'
      }
    }) as Promise<EventResponse[]>;

    const onDemandEventsPromise = canRegisterToOnDemandEvents
      ? (listEvents({
          queryParams: {
            organization: orgId,
            series: seriesId,
            on_demand_mode: true,
            ordering: 'start_time'
          }
        }) as Promise<EventResponse[]>)
      : Promise.resolve([] as EventResponse[]);

    const [liveAndUpcomingEvents, onDemandEvents] = await Promise.all([
      liveAndUpcomingEventsPromise,
      onDemandEventsPromise
    ]);

    const seenIds = new Set(liveAndUpcomingEvents.map(e => e.id));
    const onDemandEventIds: string[] = [];
    const mergedOnDemand: EventResponse[] = [];

    for (const event of onDemandEvents) {
      onDemandEventIds.push(event.id);
      if (!seenIds.has(event.id)) {
        mergedOnDemand.push(event);
        seenIds.add(event.id);
      }
    }

    return { allEvents: [...liveAndUpcomingEvents, ...mergedOnDemand], onDemandEventIds };
  },

  loadSeriesEvents({ commit, rootGetters }, seriesId: string) {
    const orgId = rootGetters['org/getCurrentOrgId'];
    commit('setIsFetchingEvents', true);

    return new Promise((resolve, reject) => {
      listEvents({
        queryParams: {
          organization: orgId,
          series: seriesId
        }
      })
        .then(eventsInSeries => {
          const transformedEvents = {};
          (eventsInSeries as EventResponse[]).forEach(event => {
            transformedEvents[event.id] = event;
          });
          commit('setEvents', transformedEvents);
          resolve(eventsInSeries);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit('setIsFetchingEvents', false);
        });
    });
  }
};

export default actions;
